import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OutlineLink, FlatButton, Spacing, OutlineButton } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import './PointsSlider/PointsSlider.scss';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';

/** Button to add points to the wallet within a external url */
function AddPointsButton({
  rechargeURL,
  tooltipPosition = 'right',
  handleUpdateWallet,
  enableFundWidget,
  handleOpenFundWidget,
}) {
  const { t: tPayment } = useTranslation('payment');
  const [showReloadButton, setReloadButton] = useState(false);
  const { travelpassLoyaltyConfig } = useWhitelabelEnvs();
  const prefix = travelpassLoyaltyConfig?.prefix || 'costapass';

  /** Add money handler */
  const addClick = () => {
    setReloadButton(true);
  };

  /** Update wallet handler */
  const updateClick = () => {
    setReloadButton(false);
    handleUpdateWallet?.();
  };

  return (
    <Spacing alignItems="center" justifyContent="center">
      {showReloadButton && (
        <FlatButton onClick={updateClick} size="S">
          {tPayment('button.reload_wallet_balance')}
        </FlatButton>
      )}
      <Tooltip
        text={tPayment('label.add_balance_costapass_wallet', { context: prefix })}
        horizontal={tooltipPosition}
      >
        {!enableFundWidget ? (
          <OutlineLink
            iconType="PlusSign"
            mobileSize="S"
            variant="primary"
            href={rechargeURL}
            newTab
            padding="M"
            onClick={addClick}
          >
            {tPayment('label.add_balance')}
          </OutlineLink>
        ) : (
          <OutlineButton
            text={tPayment('button.add_funds')}
            iconType="Plus"
            padding="L"
            variant="primary"
            onClick={handleOpenFundWidget}
            weight="regular"
            fontSize="S"
          />
        )}
      </Tooltip>
    </Spacing>
  );
}

AddPointsButton.propTypes = {
  rechargeURL: PropTypes.string,
  tooltipPosition: PropTypes.string,
  handleUpdateWallet: PropTypes.func,
  enableFundWidget: PropTypes.bool,
  handleOpenFundWidget: PropTypes.func,
};

export default AddPointsButton;
